export function sortItemsToFacet( sortItems ) {
	return {
		associatedFieldName: 'SortItems',
		detailedLinks: 5,
		elements: sortItems,
		filterStyle: "DEFAULT",
		hidden: true,
		name: "Sortieren",
		selectedElements: [],
		selectionType: 'singleShowUnselected',
		showPreviewImages: false,
		type: 'TEXT',
		unit: '',
	}
}

export function facetToFilterGroup( facet ) {

	// Already transformed - happens when called from overview.
	if ( facet.transformed ) {
		return facet;
	}

	const EN_KO = window.EN_KO;

	// TODO: Transform Factfinder FacetFilter into Shop-conforming filterGroup.
	const { associatedFieldName: identifier, name, elements, selectedElements } = facet;
	const data = {};

	let type = 'checkbox';
	switch ( facet.filterStyle ) {
		case 'SLIDER':
			type = 'pricerange'
			data['nonlinear'] = true;
			break;

		default:
			if ( [ 'singleHideUnselected', 'singleShowUnselected' ].includes( facet.selectionType ) ) {
				type = 'radio';
			}

			switch ( identifier ) {
				case 'Colorgrouping':
					data['variant'] = 'colors';
					break;
			}
	}

	return {
		name,
		identifier,
		type,
		input_name: identifier.toLowerCase(),
		count: selectedElements.length,
		search: [ 'checkbox', 'radio' ].includes( type ) && elements.length > 12,
		filter: [...selectedElements, ...elements].map( ( { text, selected, totalHits, searchParams, ...filter }, index ) => {
			let extra = {};
			if ( 'pricerange' === type ) {
				extra = {
					...extra,
					currency: facet.unit,
					range: {
						from: filter.selectedMinValue,
						to: filter.selectedMaxValue,
						min: filter.absoluteMinValue,
						max: filter.absoluteMaxValue,
						norm_from: EN_KO.functions.normalize( filter.selectedMinValue, [filter.absoluteMinValue, filter.absoluteMaxValue], true ),
						norm_to: EN_KO.functions.normalize( filter.selectedMaxValue, [filter.absoluteMinValue, filter.absoluteMaxValue], true ),
					}
				}
			} else if ( 'Colorgrouping' === identifier ) {
				extra = {
					...extra,
					// ucFirst each color.
					label: String( text ).trim().split( /\s/g ).map( ( part ) => [ part.slice( 0, 1 ).toUpperCase(), part.slice( 1 ) ].join( '' ) ).join( ' ' ),
				}
			} else if ( 'Geschlecht' === identifier ) {
				extra = {
					...extra,
					isChild: [ 'Mädchen', 'Jungen' ].includes( text ),
				}
			} else if ( 'Saison' === identifier ) {
				const saisonLabels = {
					'Summer': 'Frühjahr/Sommer',
					'Winter': 'Herbst/Winter',
				}
				extra = {
					...extra,
					label: saisonLabels[ text ] ?? text,
				}
			} else if ( 'salesrange' === identifier ) {
				const salesrangeLabels = {
					'19': 'bis zu 20%',
					'20': 'bis zu 30%',
					'30': 'bis zu 40%',
					'40': 'bis zu 50%',
					'50': 'bis zu 60%',
					'60': 'bis zu 70%',
				}
				extra = {
					...extra,
					label: salesrangeLabels[ text ] ?? text,
				}
			} else if ( 'Besonderheiten' === identifier ) {
				const ACL_BADGE_DEFS = window.ACL_BADGE_DEFS || {};
				extra = {
					...extra,
					label: String( ACL_BADGE_DEFS[ text.replace( ' ', '_' ) ]?.title ?? text ).toUpperCase(),
				}
			} else if ( 'SortItems' === identifier ) {
				extra = {
					...extra,
					label: filter.label,
					value: filter.description,
					hidden: true,
				}
			}

			return {
				transformed: true,
				filterId: [ identifier, index, text ].join( '_' ).replace( /\W+/g, ' ' ).replace( /\s+/g, '_' ).toLowerCase(),
				label: text,
				value: text,
				selected: String( selected ).toLowerCase() === 'true',
				count: totalHits,
				data: {
					searchParams,
				},
				...extra
			}
		} ),
		facet,
		...data
	};
}

export function arrayEquals( a, b ) {
	return Array.isArray( a ) &&
		Array.isArray( b ) &&
		a.length === b.length &&
		a.every( ( val, index ) => val === b[index] );
}

export function objectEquals( a, b ) {
	return JSON.stringify( a ) === JSON.stringify( b );
}

export function objectDeepEquals( a, b ) {

	const objKeys1 = Object.keys( a );
	const objKeys2 = Object.keys( b );

	if ( objKeys1.length !== objKeys2.length ) return false;

	for ( var key of objKeys1 ) {
		const value1 = a[key];
		const value2 = b[key];

		const isObjects = isObject( value1 ) && isObject( value2 );

		if ( ( isObjects && !objectDeepEquals( value1, value2 ) ) ||
			( !isObjects && value1 !== value2 )
		) {
			return false;
		}
	}
	return true;
}

export function isObject( object ) {
	return object != null && typeof object === "object";
}
